import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Components
import { Button, Link, MessageError } from "../../components/atoms";
import { InputGroup } from "../../components/molecules";

// Components Styled Component
import {
  ImageContainer,
  ImageWrapper,
  LinkStyle,
  Main,
  WrapperForm,
} from "./styles";

// Imagens
import loginIlustration from "../../assets/img/banner_inicial.jpg";
import logoBiotur from "../../assets/img/logo_biotur.png";

// auth
import { AuthContext } from "../../contexts/Auth/AuthContext";

export function Login() {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const { baixareserva } = useParams();

  const [user, setUser] = useState<userRequest>({
    usuario: null,
    senha: null,
  });

  const [messageError, setMessageError] = useState(false);

  useEffect(() => {
    // Clear any existing error message when the component mounts
    setMessageError(false);
  }, []);

  const fetchApiAuth = async () => {
    if (user.usuario && user.senha) {
      try {
        const webtuorData = await auth.login(user);

        if (webtuorData) {
          const redirectUri = localStorage.getItem("redirectUri");

          if (webtuorData.acesso === "TROCAR SENHA") {
            navigate("/auth/alterar-senha");
          } else if (redirectUri) {
            localStorage.removeItem("redirectUri");
            navigate(redirectUri);
          } else if (baixareserva) {
            navigate(`/baixareserva/${baixareserva}`);
          } else {
            navigate("/");
          }
        }
      } catch (error) {
        setMessageError(true);
      }
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMessageError(false);
    setUser({
      ...user,
      [e.target.id]: e.target.value,
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      fetchApiAuth();
    }
  };

  return (
    <Main className="container-fluid vh-100">
      <div className="row vh-100 align-items-center">
        <ImageWrapper className="col-sm-12 col-md-6 col-lg-8 d-none d-md-block">
          <ImageContainer>
            <img
              src={loginIlustration}
              alt="Imagem ilustrativa"
              className="ilustracao"
            />
          </ImageContainer>
        </ImageWrapper>

        <WrapperForm className="col-sm-12 col-md-6 col-lg-4">
          <img src={logoBiotur} alt="Logotipo da Biotur" />

          <h1>Controle de Acesso</h1>
          <p></p>
          <p>Versão 1.01.35</p>

          <MessageError>
            {messageError ? "Usuário ou senha inválidos!" : ""}
          </MessageError>

          <InputGroup
            id="usuario"
            label="Email"
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            required
          />

          <InputGroup
            id="senha"
            type="password"
            label="Senha"
            autoComplete="on"
            hasPasswordType={true}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            required
          />

          <LinkStyle className="text-center">
            <Link to="/auth/esqueci-minha-senha">Esqueci minha senha</Link>
          </LinkStyle>

          <Button appearance="primary" onClick={fetchApiAuth}>
            Entrar
          </Button>

          <span className="text-center">
            <Link to="/auth/cadastro">Cadastre-se</Link> caso não tenha uma
            conta.
          </span>
        </WrapperForm>
      </div>
    </Main>
  );
}
